import { Injectable } from '@angular/core';
import { ViewMeetingsDetail } from './../models/view-meeting.model';
import { Constants } from '../constants';
import moment from 'moment';
import { GlobalConstants } from '../global-constants';

@Injectable({
    providedIn: 'root'
})
export class ViewMeetingMapping {
    constructor(private constants: Constants, private globalConstants: GlobalConstants) {
    }

    public getMeetingDetails(responseData: any): ViewMeetingsDetail {
        const ViewMeetingDetail = new ViewMeetingsDetail();
        ViewMeetingDetail.adjourned = responseData.adjourned;
        ViewMeetingDetail.agendaExists = responseData.agendaExists;
        ViewMeetingDetail.agendaTitle = responseData.agendaTitle;
        ViewMeetingDetail.attendees = responseData.attendees;
        ViewMeetingDetail.colorHexCode = responseData.meetingTypeColor;
        ViewMeetingDetail.description = responseData.description;
        ViewMeetingDetail.endDateTime = moment.parseZone(responseData.endDateTime).format(this.globalConstants.format.cardDateFormat);
        ViewMeetingDetail.endTime = responseData.endTime;
        ViewMeetingDetail.location = responseData.location;
        ViewMeetingDetail.meetingId = responseData.meetingId;
        ViewMeetingDetail.meetingRecurringId = responseData.meetingRecurringId;
        ViewMeetingDetail.meetingTitle = responseData.meetingTitle;
        ViewMeetingDetail.meetingTypeBackgroundColor = responseData.meetingTypeBackgroundColor;
        ViewMeetingDetail.meetingTypeDescription = responseData.meetingTypeDescription;
        ViewMeetingDetail.meetingTypeId = responseData.meetingTypeId;
        ViewMeetingDetail.meetingTypeName = responseData.meetingTypeName;
        ViewMeetingDetail.minutesMeetingExists = responseData.minutesMeetingExists;
        ViewMeetingDetail.recurring = responseData.recurring;
        ViewMeetingDetail.recurringId = responseData.recurringId;
        ViewMeetingDetail.recurringType = responseData.recurringType;
        ViewMeetingDetail.startDateTime = moment.parseZone(responseData.startDateTime).format(this.globalConstants.format.cardDateFormat);
        ViewMeetingDetail.startTime = responseData.startTime;
        ViewMeetingDetail.staticEndDate = responseData.staticEndDate;
        ViewMeetingDetail.templates = responseData.templates;
        ViewMeetingDetail.type = responseData.type;
        ViewMeetingDetail.meetingAgendaId = responseData.meetingAgendaId;
        ViewMeetingDetail.agendaStatus = responseData.agendaStatus;
        ViewMeetingDetail.base64ThumbnailsString = 'data:image/png;base64,' + responseData.base64ThumbnailsString;
        ViewMeetingDetail.minutesStatus = responseData.minutesStatus;
        ViewMeetingDetail.minutesId = responseData.minutesId;
        ViewMeetingDetail.base64ThumbnailsStringForMinutes = 'data:image/png;base64,' + responseData.minutesBase64ThumbNails;
        ViewMeetingDetail.newMeetingDate = responseData.newMeetingDate;
        ViewMeetingDetail.newMeetingTime = responseData.newMeetingTime;
        ViewMeetingDetail.importAgenda = responseData.importAgenda;
        ViewMeetingDetail.importMinutes = responseData.importMinutes;
        ViewMeetingDetail.publicAgendaSummery = responseData.base64AgendaString;
        ViewMeetingDetail.publicAgendaPacket = responseData.base64AgendaStringPacket;
        ViewMeetingDetail.publicMinutes = responseData.binaryString;
        ViewMeetingDetail.videoId = responseData.videoId;
        ViewMeetingDetail.videoStatus = responseData.videoStatus;
        ViewMeetingDetail.locationUploadUrl = responseData.locationUploadUrl;
        ViewMeetingDetail.thumbnailOfVideo = responseData.videoId ? this.constants.thumbnailUrl.replace('videoId', responseData.videoId) : '';
        ViewMeetingDetail.canceled = responseData.canceled;
        ViewMeetingDetail.uploadMinutesVideo = responseData.videoId && !responseData.canceled ? true : false;
        ViewMeetingDetail.uploadMinutesVideoURL = 'https://www.youtube.com/watch?v=' + responseData.videoId;
        ViewMeetingDetail.agendaPacketEnabled = responseData.agendaPacketEnabled;
        ViewMeetingDetail.minutesPacketEnabled = responseData.minutesPacketEnabled;
        let packetFileSizeThreshold = responseData.packetFileSizeThreshold ? responseData.packetFileSizeThreshold : 300 * 1024 * 1024;
        ViewMeetingDetail.packetFileSizeExceeded = responseData.packetFileSize ? responseData.packetFileSize >= packetFileSizeThreshold : false;

        ViewMeetingDetail.packetFileSizeThreshold = packetFileSizeThreshold / 1024 / 1024;
        return ViewMeetingDetail;
    }
}
